import React from 'react'
import { FlexRow, Text, DelayRender } from 'elements'
import Header from './Header'
import PageBody from './PageBody'

export default function PageBodyLoading() {
  return (
    <PageBody
      renderHeader={() => (
        <>
          <Header>
            <FlexRow>
              <DelayRender delay={1000}>
                <Text color="neutral.0" fontSize="xlarge" lineHeight="xlarge" fontWeight="bold">
                  Loading...
                </Text>
              </DelayRender>
            </FlexRow>
          </Header>
          <FlexRow bg="nav.secondary" height="60px" />
        </>
      )}
      renderContent={() => null}
    />
  )
}
